<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">Проекты</h2>
      <div class="btn-group float-right" role="group">
        <button class="btn btn-sm btn-primary" v-if="!reorder" @click="switchReorder()"><font-awesome-icon icon="fas fa-edit" /> Изменить порядок</button>
        <button class="btn btn-sm btn-danger" v-else @click="switchReorder()"><font-awesome-icon icon="fas fa-ban" /> Отмена</button>

        <button v-if="!reorder" class="btn btn-success" @click="newProject()"><font-awesome-icon icon="fas fa-plus" /> Добавить проект</button>
      </div>
    </div>
    <template v-if="!reorder">
      <div class="card">
        <div class="card-header p-0">
          <div class="d-flex justify-content-between w-100">
            <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
              <div class="input-group-prepend">
                <span class="input-group-text border-0">
                  <font-awesome-icon icon="fas fa-search" />
                </span>
              </div>
              <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
            </div>
          </div>
        </div>
      </div>
      <div class="blog-list-wrapper">
        <div class="row">
          <template v-if="projects && projects.length > 0">
            <div class="col-md-3 col-12 mb-3" v-for="project in projects">
              <div class="card h-100">
                <div class="card-body d-flex flex-column" style="border-radius: 0.428rem;">
                  <h5 class="card-title">{{project.short_name}}</h5>
                  <div class="card-text" v-html="project.short_description"></div>

                  <div class="d-flex justify-content-between align-items-center mt-auto">
                    <button @click="openProject(project.id)" class="btn btn-outline-success"><font-awesome-icon icon="fas fa-eye" /></button>
                    <button @click="editProject(project)" class="btn btn-outline-primary"><font-awesome-icon icon="fas fa-edit" /></button>
                    <button @click="deleteProject(project.id)" class="btn btn-outline-danger"><font-awesome-icon icon="fas fa-trash" /></button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-md-3 col-12">
              <div class="card">
                <div class="card-body">
                  <h3>Нет данных для отображения</h3>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <nav v-if="projects && projects.length > 0" class="justify-content-between d-flex align-items-center">
        <div class="p-2">
          <label for="inputState" class="form-label mb-0">На странице: </label>
          <select class="form-select" v-model="perPage" @change="changePerPage()">
            <option :value="value" v-for="value in perPageList">{{value}}</option>
          </select>
        </div>
        <ul class="pagination mb-0" v-if="lastPage > 1">
          <li class="page-item">
            <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
              <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" @click.prevent="prevPage()" href="#">
              <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
            </a>
          </li>
          <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
            <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
          </li>
          <li class="page-item">
            <a class="page-link" @click.prevent="nextPage()" href="#">
              Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
              Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
            </a>
          </li>
        </ul>
        <div class="p-2">
          <p class="mb-0">(Всего страниц: {{lastPage}})</p>
        </div>
      </nav>
    </template>
    <template v-else>
      <div class="row">
        <draggable class="list-group h-100 w-100" group="projects" :list="projects" @change="reSort">
          <div class="col-12" v-for="(project, index) in projects" :key="project.id">
            <div class="card border" style="cursor: pointer;">
              <div class="row g-o">
                <div class="col-1">
                  <div class="card-body d-flex flex-column align-items-center">
                    <h5 class="card-title">{{index + 1}}</h5>
                    <font-awesome-icon icon="fas fa-arrows" size="2x" />
                  </div>
                </div>
                <div class="col-4">
                  <div class="card-body">
                  <h5 class="card-title">{{project.short_name}}</h5>
                </div>
                </div>
                <div class="col-7">
                  <div class="card-body">
                    <div class="card-text" v-html="project.short_description"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </template>

    <!-- Modal Create/Edit Project -->
    <div class="modal modal-slide-in fade" id="addNew" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title" v-show="!editmode">Создание</h5>
            <h5 class="modal-title" v-show="editmode">Редактирование</h5>
          </div>
          <form @submit.prevent="editmode ? updateProject() : createProject()">
            <div class="modal-body">
              <div class="form-group">
                <label>Краткое наименование</label>
                <input v-model="projectform.short_name" type="text"placeholder="Краткое наименование" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Краткое описание</label>
                <vue-editor v-model="projectform.short_description" rows="3" placeholder="Краткое описание"></vue-editor>
              </div>
              <div class="form-group">
                <label>Запись данных в журнал учета ДСП документов</label>
                <select v-model="projectform.logging" class="form-control">
                  <option value="0">Не вести</option>
                  <option value="21">Оценки</option>
                  <option value="77">Аттестации</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Modal Create/Edit Project -->

  </div>
</template>


<script>
import { VueEditor } from "vue2-editor";
import draggable from 'vuedraggable';
  export default {
    components: {
      draggable, VueEditor
    },
    computed: {
      startPage() {
        if (this.currentPage < 4) {
          return 1;
        }
        if (this.currentPage == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 1) == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 2) == this.lastPage) {
          return this.startPage2;
        }
        return this.currentPage - 3;
      },
      startPage2(){
        if(this.lastPage > 6){
          return this.lastPage - 6;
        }
        if(this.lastPage > 5){
          return this.lastPage - 5;
        }
        if(this.lastPage > 4){
          return this.lastPage - 4;
        }
        if(this.lastPage > 3){
          return this.lastPage - 3;
        }
        if(this.lastPage > 2){
          return this.lastPage - 2;
        }
      },
      visiblePages() {
        let pages = [];
        let start = this.startPage;
        let end = Math.min(this.startPage + 6, this.lastPage);
        for (let i = start; i <= end; i++) {
          pages.push({
            name: i,
            active: i == this.currentPage
          });
        }
        return pages;
      }
    },
    data () {
      return {
        reorder: false,
        drafts: [],
        projects: [],
        searchQuery: '',
        currentPage: 1,
        lastPage: 1,
        firstPage: 1,
        timeout: null,
        perPage: 25,
        perPageList: [10, 25, 50, 100],
        editmode: false,
        projectform: new Form({
          id: '',
          short_name: '',
          short_description: '',
          logging: false,
        })
      }
    },
    methods: {
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      switchReorder(){
        if(!this.reorder){
          this.loadAllProjects();
        }else{
          this.loadProjects();
        }
        this.reorder = !this.reorder;
      },
      reSort(){
        this.$Progress.start();
        let projects = [];
        this.projects.forEach((item, key) => {
          projects.push({id: item.id, sort: key})
        });
        const data = new FormData();
        data.append('projects', JSON.stringify(projects));
        axios.post('/api/project/resort', data)
        .then((response) => {
          this.loadProjects();
          this.SuccessToast();
          this.$Progress.finish();
        })
        .catch(() => {
          this.ErrorToast();
          this.$Progress.fail();
        });
      },
      newProject(){
        this.editmode = false;
        this.projectform.reset();
        $('#addNew').modal('show');
      },
      editProject(project){
        this.editmode = true;
        this.projectform.reset();
        this.projectform.id = project.id;
        this.projectform.short_name = project.short_name;
        this.projectform.short_description = project.short_description;
        this.projectform.logging = project.logging;
        $('#addNew').modal('show');
      },
      openProject(id){
        this.$router.push({
          name: 'project.organization',
          params: { id: id }
        });
      },
      nextPage(){
        if(this.currentPage < this.lastPage){
          this.currentPage++;
          this.loadProjects();
        }
      },
      selectPage(number){
        this.currentPage = number;
        this.loadProjects();
      },
      prevPage(){
        if(this.currentPage > 1){
          this.currentPage--;
          this.loadProjects();
        }
      },
      changePerPage(){
        this.currentPage = 1;
        this.loadProjects();
      },
      search(){
        if(this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$Progress.start();
          this.currentPage = 1;
          this.loadProjects();
          this.$Progress.finish();
        }, 500);

      },
      createProject(){
        this.$Progress.start();
        this.projectform.post('/api/project')
        .then((response)=>{
          $('#addNew').modal('hide');
          this.SuccessToast();
          this.loadProjects();
          this.$parent.$parent.loadProjects();
          this.projectform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      updateProject(){
        this.$Progress.start();
        this.projectform.put('/api/project/'+this.projectform.id)
        .then((response) => {
          $('#addNew').modal('hide');
          this.SuccessToast();
          this.loadProjects();
          this.$parent.$parent.loadProjects();
          this.projectform.reset();
          this.$Progress.finish();
        })
        .catch(() => {
          this.ErrorToast();
          this.$Progress.fail();
        });
      },
      deleteProject(id){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
          }).then((result) => {
           if (result.value) {
              this.projectform.delete('/api/project/'+id).then(()=>{
                this.SuccessToast();
                this.loadProjects();
                this.$parent.$parent.loadProjects();
              }).catch((data)=> {
                this.ErrorToast();
              });
            }
          })
        },
      loadAllProjects(){
        axios.get('/api/project?page=1&search=&perPage=10000').then(({ data }) => {
          this.projects = data.data;
        });
      },
      loadProjects(){
        axios.get('/api/project?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
          this.projects = data.data;
          this.lastPage = data.last_page;
        });
      }
    },
    created() {
      this.$Progress.start();
      this.loadProjects();
      this.$Progress.finish();
    }
  }
</script>
